export default function checkPath(path) {
    if (!path)
        return '/';

    if (path.endsWith("/") == false) {
        path = path + '/'
    }

    if (path.startsWith('/') == false) {
        path = '/' + path
    }
    return path;
}